<template>
<div>
  <v-autocomplete
  ref="autocomplete"
    auto-select-first
    clearable
    :no-filter="true"
    :items="options"
    v-model="innerValue"
    item-text="text"
    item-value="value"
    @blur="emitBlur"
    :filter="() => true"
    :solo="solo"    
    v-bind="resetProps"
  >
</v-autocomplete>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    value: [Object, String, Number],
    solo: Boolean,
    hideDetails: Boolean,
    dense: Boolean,
  },
  data() {
    return {
      innerValue: this.value
    };
  },

  async created() {
      await this.getAll();
      // setTimeout(() => {
      //   this.innerValue = this.value;
      //   let foundObject = this.options.find((o) => o.value == this.innerValue);
      //   if (foundObject) {
      //     this.$refs.autocomplete.internalSearch = foundObject.text;
      //     this.$refs.autocomplete.initialValue = foundObject;
      //   }        
      // }, 100);
  },

  watch: {
    value(n) {
        this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },  

  methods: {
      ...mapActions('userGroup', ['getAll']),
      emitBlur() {
        this.$emit('blur');
      }
  },

  computed: {
    ...mapState({
      userGroup: (state) => state.userGroup,
    }),
    resetProps() {
      return {...this.$attrs};
    },
    options() {
      return this.userGroup.data.map((userGroup) => {
        return {
          value: userGroup.id,
          text: userGroup.name,
        };
      });
    },
  },
};
</script>